import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
import { LoadingSpinner } from '../common/LoadingSpinner';
import { UserRole } from '../../types';

interface ProtectedRouteProps {
	children: ReactNode;
	allowedRoles?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
	const { user, isAuthenticated, loading } = useAuth();

	if (loading) {
		return <LoadingSpinner />;
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	// Check role-based access if allowedRoles is specified
	if (allowedRoles && allowedRoles.length > 0) {
		if (!user || !allowedRoles.includes(user.role)) {
			// Redirect to unauthorized page or dashboard
			return (
				<div className="min-h-screen bg-gray-50 flex items-center justify-center">
					<div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
						<div className="text-center">
							<div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
								<svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										strokeWidth={2}
										d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
									/>
								</svg>
							</div>
							<h3 className="text-lg font-medium text-gray-900 mb-2">Access Denied</h3>
							<p className="text-sm text-gray-500 mb-4">You don't have permission to access this page.</p>
							<button
								onClick={() => (window.location.href = '/dashboard')}
								className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm font-medium">
								Go to Dashboard
							</button>
						</div>
					</div>
				</div>
			);
		}
	}

	return <>{children}</>;
};
